import headerImg from '../images/Stepper4.png';
import subAPImg from '../images/SubAPStepper3.png';
import pStepper from '../hybridImages/PStepper4.png';
import nonPStepper from '../hybridImages/Stepper2TandC.png';
import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import { TermsFormCheckboxNoErrMsgDisplay } from '../validation/Form-Components';
import SubHeader from '../components/SubHeader';
import { useEffect, useState } from 'react';
import helper from '../factory/Helper';
import { useHistory } from 'react-router-dom';
import FormContainer from '../components/FormContainer';
import declareData from '../data/declarationsdata.json';
import config from '../appconfig/config.json';
import { certBoardResoValidator } from '../validation/Validators';
import DeclarationDtlsItem from '../components/DeclarationDtlsItem';
import Popup from '../components/CusPopup';
import service from '../services/PreviewApiService';
import storage from '../factory/StorageFactory';
import CusToast from '../components/CusToast';
import Loading from '../components/Loading';
import { Button } from '@progress/kendo-react-buttons';

const DeclarationsDetails = (props) => {

    let timer;
    const history = useHistory();
    const AL1 = 'AL1', AL2 = 'AL2', AL3 = 'AL3', AL4 = 'AL4', AL5 = 'AL5', AL6 = 'AL6';

    const [isError, setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [buttonPopup, setButtonPopup] = useState(false);
    const [declartionsDtls, setDeclartionsDtls] = useState({
        applicantDeclare: false
    });

    const [AL1Clicked, setAL1Clicked] = useState(false);
    const [AL2Clicked, setAL2Clicked] = useState(false);
    const [AL3Clicked, setAL3Clicked] = useState(false);
    const [AL4Clicked, setAL4Clicked] = useState(false);
    const [AL5Clicked, setAL5Clicked] = useState(false);
    const [AL6Clicked, setAL6Clicked] = useState(false);
    const [isSaving,setIsSaving] = useState(false);

    useEffect(() => {

        if (helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        
        if(helper.isInvalidState()) {
            window.location.href =  config.link.BacktoHome;
            return;
        }

        getData();
        window.scrollTo(0, 0);
        return () => clearTimeout(timer);
    }, []);

    const handleSubmit = (dataItem) => {

        if (helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        
        if(helper.isInvalidState()) {
            window.location.href =  config.link.BacktoHome;
            return;
        }

        if (dataItem.isValid) {
            let data = JSON.parse(JSON.stringify(dataItem.values));
            if (history.location.state !== undefined) {
                saveDeclareDetails();
            }
            else {
                
                //22/02/2023 Ish asked to removed the link clicked
                /*
                if (validateLinkClicked() === false) {
                    let errMsg = '';
                    if (!AL1Clicked)
                        errMsg = declareData.invalidClicked + '\n(Terms and Conditions for the SME e-Financing Application)';
                    else if (!AL2Clicked)
                        errMsg = declareData.invalidClicked + '\n(MayBank’s Data Protection Policy)'
                    else if (!AL3Clicked)
                        errMsg = declareData.invalidClicked + '\n(Advisory from the Singapore Police Force.)'
                    else if (!AL4Clicked)
                        errMsg = declareData.invalidClicked + '\n(Terms and Conditions of Internet Banking Services)'
                    else if (!AL5Clicked)
                        errMsg = declareData.invalidClicked + '\n(Terms and Conditions of Access)'
                    else if (!AL6Clicked)
                        errMsg = declareData.invalidClicked + '\n(Maybank’s Data Protection Policy)'
                    showErrMsg(errMsg);
                    return;
                }
                */
             
                saveDeclareDetails();
            }
        }
    }

    const getData = () => {
        if (history.location.state !== undefined) {
            if (history.location.state.from === config.route.Preview) {
                setDeclartionsDtls({
                    applicantDeclare: true
                })
            }
        }
    }

    const validateLinkClicked = () => {

        if (AL1Clicked && AL2Clicked && AL3Clicked && AL4Clicked && AL5Clicked && AL6Clicked) {
            return true;
        }
        else {
            return false;
        }
    }

    const saveDeclareDetails = () => {
        setIsSaving(true);
        let status = true;
        service.putTermsAndDeclare(status).then(res => {
            setIsSaving(false);
            let resData = res.data;
            if (resData.isSucess) {
                goNext();
            }
            else {
                showErrMsg(config.error.SaveApiFailed);
            }
        })
        .catch(err => {
            setIsSaving(false);
            console.log('err ',err);
            showErrMsg(config.error.SaveApiFailed);
        })
    }

    const handleBack = (e) => {
        e.preventDefault();
        if (storage.getIsFirstTime() === "true") {
            if(storage.getIsFProdBTL() === 't') { //BTL existing flow
                history.push(config.route.AccountDetails);
            }
            else {
                if(storage.getIsFPTypeProperty() === 't') {
                    if(storage.getIsPureAIP() === 'true') {
                        history.push(config.route.PropertyDetailsAIP);
                    }
                    else {
                        history.push(config.route.PropertyDetails);
                    }
                }
                else {
                    history.push(config.route.NSPersonDetails);
                }
            }
        }
        else {
            history.push(config.route.NSPersonDetails);
        }
    }

    const showPopUpMsg = (e) => {
        e.preventDefault();
        setButtonPopup(true)
    }

    const goNext = () => {
        if (history.location.state !== undefined) {
            if (history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            history.push(config.route.Preview);
        }
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout()
    }

    const setErrMsgTimeout = () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const handleALinkClick = (id) => {
        if (id === AL1) {
            setAL1Clicked(true);
            window.open(declareData.termsandCons[0].hrefLink);
        }
        if (id === AL2) {
            setAL2Clicked(true);
            window.open(declareData.termsandCons[0].hrefLink2);
        }
        if (id === AL3) {
            setButtonPopup(true);
            setAL3Clicked(true);
        }
        if (id === AL4) {
            setAL4Clicked(true);
            window.open(declareData.termsandCons[2].hrefLink);
        }
        if (id === AL5) {
            setAL5Clicked(true);
            window.open(declareData.termsandCons[2].hrefLink2);
        }
        if (id === AL6) {
            setAL6Clicked(true);
            window.open(declareData.termsandCons[2].hrefLink3);
        }
    }

    return (
        <div className="container-fluid">
            {(storage.getIsFirstTime() === 'false')?
            <SubHeader title={config.Branding.title} img={subAPImg} />
            :
            <>
            {(storage.getIsFProdBTL() === 't')?
            <SubHeader title={config.Branding.title} img={headerImg} />
            :
            <SubHeader title={config.Branding.title} img={(storage.getIsFPTypeProperty()==='t')?pStepper:nonPStepper} />
            }
            </>
            }

         
            <br />
 
            <Form onSubmitClick={handleSubmit}
                initialValues={declartionsDtls}
                key={JSON.stringify(declartionsDtls)}
                render={(formRenderProps) => (
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <FieldWrapper>
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                                                <div>{declareData.title}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <Field name={'applicantDeclare'} label={declareData.chkApplicantDeclare} id={'applicantDeclare'}
                                        component={TermsFormCheckboxNoErrMsgDisplay} value={true} validator={certBoardResoValidator} />

                                    <DeclarationDtlsItem
                                        id={declareData.termsandCons[0].id} lblname={(<>{declareData.termsandCons[0].lblname1}
                                            <a className="txtBlue"
                                                onClick={(e) => { e.preventDefault(); handleALinkClick(AL1) }}
                                                href={declareData.termsandCons[0].hrefLink} target="_blank" >
                                                {declareData.termsandCons[0].lblname2}</a> {declareData.termsandCons[0].lblname3}
                                            <a className="txtBlue"
                                                onClick={(e) => { e.preventDefault(); handleALinkClick(AL2) }}
                                                href={declareData.termsandCons[0].hrefLink2} target="_blank">
                                                {declareData.termsandCons[0].lblname4}</a>{declareData.termsandCons[0].lblname5}</>)} />

                                    <DeclarationDtlsItem
                                        id={declareData.termsandCons[1].id} lblname={(<>{declareData.termsandCons[1].lblname1}
                                            <a id={'a3'} className="txtBlue"
                                                onClick={(e) => { e.preventDefault(); handleALinkClick(AL3) }}
                                                href={declareData.termsandCons[1].hrefLink} target="_blank">{declareData.termsandCons[1].lblname2}</a>
                                        </>)} />
                                    
                        
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div style={{width:'100%',paddingLeft:'5%'}}>
                                                <div style={{width:'3%',float:'left'}}>
                                                    <span style={{height:'7px',width:'7px',borderRadius:'50%',display:'inline-block',backgroundColor:'#495057'}} />    
                                                </div>
                                                <div style={{width:'92%',float:'left'}}>
                                                    <label id={declareData.termsandCons[2].id}>{declareData.termsandCons[2].lblTitle}</label> 
                                                    <div style={{width:'100%'}}>
                                                        <div style={{display:'inline-flex'}}>
                                                            <span className="k-icon k-i-check"  style={{marginTop:'5px'}}/>&nbsp;&nbsp;
                                                            <a id={'a4'} className="txtBlue"
                                                                href={declareData.termsandCons[2].hrefLink} target="_blank"
                                                                onClick={(e) => { 
                                                                    e.preventDefault(); 
                                                                    handleALinkClick(AL4)
                                                                }}>
                                                            {declareData.termsandCons[2].lblname}
                                                            </a>
                                                        </div>
                                                        <div>
                                                            <span className="k-icon k-i-check" />&nbsp;&nbsp;
                                                            <a id={'a5'} className="txtBlue"
                                                                href={declareData.termsandCons[2].hrefLink2} target="_blank"
                                                                onClick={(e) => { e.preventDefault(); handleALinkClick(AL5)}}>
                                                                {declareData.termsandCons[2].lblname2}
                                                            </a> 
                                                        </div>
                                                        <div>
                                                            <span className="k-icon k-i-check" />&nbsp;&nbsp;
                                                            <a id={'a6'} className="txtBlue"
                                                                href={declareData.termsandCons[2].hrefLink3} target="_blank"
                                                                onClick={(e) => { e.preventDefault(); handleALinkClick(AL6)}}>
                                                                {declareData.termsandCons[2].lblname3}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {(storage.getIsFProdBTL() === 't')&&
                                    <FieldWrapper>
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div style={{width:'100%',paddingLeft:'5%'}}>
                                                <div style={{width:'3%',float:'left'}}>
                                                    <span style={{height:'7px',width:'7px',borderRadius:'50%',display:'inline-block',backgroundColor:'#495057'}} />    
                                                </div>
                                                <div style={{width:'92%',float:'left'}}>
                                                    <label id={'dcl111'}>{declareData.termsandCons[3].lblTitle} </label> 
                                                    <br/>
                                                    
                                                    <div style={{width:'100%'}}>
                                                        <div style={{width:'4%',float:'left'}}>
                                                            <span className="k-icon k-i-check" />
                                                        </div>       
                                                        <div style={{width:'96%',float:'left'}}>
                                                            {declareData.termsandCons[3].lblname}
                                                        </div>
                                                    </div>
                                                    <div style={{width:'100%'}}>
                                                        <div style={{width:'4%',float:'left'}}>
                                                            <span className="k-icon k-i-check" />
                                                        </div>       
                                                        <div style={{width:'96%',float:'left'}}>
                                                            {declareData.termsandCons[3].lblname2}
                                                        </div>
                                                    </div>
                                                    <div style={{width:'100%'}}>
                                                        <div style={{width:'4%',float:'left'}}>
                                                            <span className="k-icon k-i-check" />
                                                        </div>       
                                                        <div style={{width:'96%',float:'left'}}>
                                                            {declareData.termsandCons[3].lblname3}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </FieldWrapper>
                                }
                                </FieldWrapper>
                            </fieldset>
                            <br/>
                        </FormContainer>
                        <FormContainer>
                            <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                                 <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className='k-font-weight-bold'>{declareData.fairDealing.title}</div><br/>
                                        <span>{declareData.fairDealing.lblname}</span>              
                                        <a id={'a6'} className="txtBlue"
                                            href={declareData.fairDealing.hrefLink} target="_blank">
                                            {'maybank.sg/fairdealing.'}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </FormContainer>
                        <FormContainer>
                            <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <Button type={'submit'} className="k-button btn btnMargin btn-success btn-float-right" disabled={!formRenderProps.valid} >{config.btnName.Next}</Button>
                                        <Button type={'button'} style={{border:'1px solid #343a40'}} className="k-button btn btnMargin btn-back" onClick={handleBack}>{config.btnName.Back}</Button>
                                    </div>
                                </div>
                            </div>
                        </FormContainer>
                        <FieldWrapper></FieldWrapper>
                    </FormElement>
                )}>
            </Form>
            {declareData.useNewSPF?
                <Popup className="popUpBox" trigger={buttonPopup} setTrigger={setButtonPopup}>
                <div style={{ textAlign: "left" }}>
                    <div className="bgBlack fbaPSize">
                        <div className="row">
                            <div className="col-11">
                                <div className="dcPgmh">{'Advisory from the Singapore Police Force - Warning'}</div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="dcPg fbaPSize">
                                {'Your payment accounts, like bank accounts are for your own use only. You may be held criminally liable if your payment account is used by others, e.g. for criminal activities.'}
                            </div>
                            <div className="dcPg fbaPSize">
                                <ol>
                                    <li><span style={{ height: '5px', width: '5px', backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }} />&nbsp;&nbsp;Do not disclose your payment accounts/credentials to anyone else. </li>
                                    <li><span style={{ height: '5px', width: '5px', backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }} />&nbsp;&nbsp;Do not let anyone else access, operate or control your payment accounts.</li>
                                    <li><span style={{ height: '5px', width: '5px', backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }} />&nbsp;&nbsp;Do not receive or transfer money for anyone else using your payment accounts, unless you know him/her and know where he/she is.</li>
                                </ol>
                            </div>
                            <div className="fbaPSize">
                                {'You can be convicted for the relevant offences under the Corruption, Drug Trafficking and other Serious Crimes (Confiscation of Benefits) Act 1992 (CDSA) if your account is used for criminal activities. A person convicted of an offence under the CDSA may be liable for a fine up to $250,000, or imprisonment of up to five years, or both.'}
                            </div>
                            <div className="dcPg fbaPSize">
                                {'You should make the necessary application to your financial institution if you wish to authorise the operation, access and/or control of your account to a third party. A failure to do so would subject your account to additional risk mitigation measures, and in some cases, your financial institution may terminate or restrict your use of your account and other related accounts you may have with your financial institution.'}
                            </div>
                        </div>
                    </div>
                </div>
                </Popup>
                :
                <Popup className="popUpBox" trigger={buttonPopup} setTrigger={setButtonPopup}>
                <div style={{ textAlign: "left" }}>
                    <div className="bgBlack fbaPSize">
                        <div className="row">
                            <div className="col-11">
                                <div className="dcPgmh">{'Advisory from the Singapore Police Force - Warning'}</div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="dcPg fbaPSize">
                                {'Your bank account should be for your own use and you are responsible for all transactions made through your bank account.'}
                            </div>
                            <div className="dcPg fbaPSize">
                                {'You may be facilitating criminal activities such as money laundering and/or unlicensed money lending if you:'}
                            </div>
                            <div className="dcPg fbaPSize">
                                <ol>
                                    <li><span style={{ height: '5px', width: '5px', backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }} />&nbsp;&nbsp;knowingly allow other people to operate, access and/or control of your bank account; and/or</li>
                                    <li><span style={{ height: '5px', width: '5px', backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }} />&nbsp;&nbsp;knowingly receive money from strangers, dubious sources, or other unverified sources</li>
                                </ol>
                            </div>
                            <div className="fbaPSize">
                                {'You can be prosecuted for the relevant offences if your bank account is used to receive or transfer money linked to criminal activities. These offences carry a punishment of a fine and/or imprisonment.'}
                            </div>
                            <div className="dcPg fbaPSize">
                                {'You should make the necessary application to your bank if you wish to authorise the operation, access and/or control of your bank account to a third party. A failure to do so would subject your bank account to additional risk mitigation measures and, in some cases, your bank may terminate or restrict your use of your bank account and other related accounts you may have with your bank.'}
                            </div>
                        </div>
                    </div>
                </div>
                </Popup>
            }
           
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  />
            {isSaving && <Loading />}
        </div>
    )
}

export default DeclarationsDetails;